import _ from 'lodash'
import { Account, Organization } from '../models'

export const filterAccounts = (accounts: Account[], searchText: string): Account[] => {
  let result = []

  if ( !searchText ) {
    result = accounts
  } else {
    result  = accounts.filter((acc) => (
      acc.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
      acc.pCode.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
      (acc.organization?.name || '').toLowerCase().indexOf(searchText.toLowerCase()) > -1
    ))
  }

  return result
}

export const sortedAccountsByDate = (accounts) =>
  accounts.sort((a, b) => {

    let compare,
      aVal = a.lastAccessed || '',
      bVal = b.lastAccessed || ''

    if (typeof aVal === 'string') {
        aVal = aVal.toUpperCase()
        bVal = bVal.toUpperCase()
    }
    if (aVal === bVal) {
        compare = 0
    } else {
        compare = aVal > bVal ? -1 : 1
    }
    return compare
  })

export const getKey = (k: string) => {
  return `gn-${k}`
}

export const getAllAccountFromLocalStorage = () =>
  JSON.parse(localStorage.getItem(getKey('all-account-accessed')) || '{}')

export const getAccountIdFromLocalStorage = () =>
  localStorage.getItem(getKey('account'))

export const getOrgIdFromLocalStorage = () =>
  localStorage.getItem(getKey('organization'))

export const setAccountIdToLocalStorage = (accountId: Account['id']) =>
  localStorage.setItem(getKey('account'), accountId.toString())

export const setOrgIdToLocalStorage = (orgId: Organization['id']) =>
localStorage.setItem(getKey('organization'), orgId.toString())

export const updateAllAccountToLocalStorage = (accountId: Account['id']) => {
  const allAccounts = getAllAccountFromLocalStorage()

  allAccounts[accountId] = new Date()
  localStorage.setItem(getKey('all-account-accessed'), JSON.stringify(allAccounts))
}

export const getOrgIdFromUrl = () => {
  const orgManagerUIMatcher = /\/org\/manager\/(\d+)(?:\/[a-zA-Z]+)?$/

  const path = window.location.pathname
  const orgMatch = path.match(orgManagerUIMatcher)

  if (orgMatch != null) {
    return Number(orgMatch[1])
  }

  return null
}

// https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
// https://github.com/facebook/react/issues/5465#issuecomment-157888325
export const makeCancelable = (promise: Promise<unknown>) => {
  let hasCanceled = false
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then((val) => hasCanceled ? reject({ isCanceled: true }) : resolve(val))
    promise.catch((error) => hasCanceled ? reject({ isCanceled: true }) : reject(error))
  })
  return {
    promise: wrappedPromise,
    cancel: () => hasCanceled = true,
  }
}

export interface CustomFetchState {
  loading?: boolean,
  error?: Error | null,
  data?: any,
}

export const customFetch = (
  url: RequestInfo,
  options: RequestInit = {},
  onUpdate: (state: CustomFetchState) => void,
) => {
  let controller = new AbortController()
  onUpdate({ loading: true })
  const fetchOptions = { ...options, signal: controller.signal }
  const cancelablePromise = makeCancelable((
    fetch(url, fetchOptions)
      .then(res => res.json())
      .then(res => onUpdate({ loading: false, error: null, data: res }))
      .catch(error => {
        if (error.name === 'AbortError') {
          onUpdate({ loading: false })
        } else {
          onUpdate({ loading: false, error })
        }
      })
      .finally(() => controller = null)
  ))
  cancelablePromise.promise.catch(_.noop) // handle cancel here if required
  const cancel = () => {
    cancelablePromise.cancel()
    controller?.abort?.()
  }
  return { promise: cancelablePromise.promise, cancel }
}
